"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rdfs = exports.subPropertyOf = exports.subClassOf = exports.range = exports.label = exports.isDefinedBy = exports.domain = exports.comment = exports.Resource = exports.Literal = exports.Datatype = exports.Class = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
const _this = __importStar(require("./rdfs"));
let dataFile = '../data/rdfs.json';
var loadData = () => JSONLD_1.JSONLD.parsePromise(Promise.resolve().then(() => __importStar(require('../data/rdfs.json'))));
exports.loadData = loadData;
exports.ns = (0, NameSpace_1.createNameSpace)('http://www.w3.org/2000/01/rdf-schema#');
exports._self = (0, exports.ns)('');
exports.Class = (0, exports.ns)('Class');
exports.Datatype = (0, exports.ns)('Datatype');
exports.Literal = (0, exports.ns)('Literal');
exports.Resource = (0, exports.ns)('Resource');
exports.comment = (0, exports.ns)('comment');
exports.domain = (0, exports.ns)('domain');
exports.isDefinedBy = (0, exports.ns)('isDefinedBy');
exports.label = (0, exports.ns)('label');
exports.range = (0, exports.ns)('range');
exports.subClassOf = (0, exports.ns)('subClassOf');
exports.subPropertyOf = (0, exports.ns)('subPropertyOf');
exports.rdfs = {
    Class: exports.Class,
    Datatype: exports.Datatype,
    Literal: exports.Literal,
    Resource: exports.Resource,
    comment: exports.comment,
    domain: exports.domain,
    isDefinedBy: exports.isDefinedBy,
    label: exports.label,
    range: exports.range,
    subPropertyOf: exports.subPropertyOf,
    subClassOf: exports.subClassOf,
};
(0, package_1.linkedOntology)(_this, exports.ns, 'rdfs', exports.loadData, dataFile);
//# sourceMappingURL=rdfs.js.map